import {
  EmailAnalysisBranch,
  EmailAnalysisEmail,
  EmailAnalysisResult,
  EmailAnalysisTabType,
} from "@types";

export interface AnalysisState {
  isLoading: {
    analyzeThread: boolean;
  };
  isError: {
    analyzeThread: boolean;
    permissionError: boolean;
    recipientsError: boolean;
  };
  activeTabId: EmailAnalysisTabType;
  result: EmailAnalysisResult | null;
  selectedBranch: EmailAnalysisBranch | null;
  selectedEmail: EmailAnalysisEmail | null;
  threadId: string | null;
  threadTrackStatus: boolean | null;
}
